import * as React from "react";

const EmptyComponent: React.FunctionComponent<any> = () => null;
export default EmptyComponent;
